import React, { useEffect, useState } from 'react'
import CMS from '../../components/cms/CMS'
import PageBanner from '../../components/general/PageBanner'
import { useTranslation } from 'react-i18next';
import CrudLanguage from './CrudLanguage';
import { useDispatch, useSelector } from 'react-redux';
import { fetchLanguageGetAll } from '../../redux/slices/languageGetAllSlice';
import { fetchLanguageDelete } from '../../redux/slices/languageDeleteSlice';
import Languages from './Languages';

const LanguagePage = () => {
    const { t } = useTranslation();
    const [modal, setModal] = useState(false)
    const [selectedItem, setSelectedItem] = useState(0)
    const [data, setData] = useState([])
    const [changed, setChanged] = useState(false)
    const dispatch = useDispatch()
    const lang = useSelector(state => state.lang.lang)

    const getData = async () => {
        const data = await dispatch(fetchLanguageGetAll())
        if (data.payload) {
            setData(data.payload)
        }
        setChanged(false)
    }

    const deleteData = async (id) => {
        await dispatch(fetchLanguageDelete({ id: id }))
        getData()
    }

    useEffect(() => { getData() }, [dispatch, changed])

    return (
        <CMS>
            <PageBanner
                title={t("language_management")}
                description={t("language_management_description")}
                modal={modal}
                setModal={setModal}
                buttonText={t("add_language")}
            />

            <Languages
                data={data}
                lang={lang}
                t={t}
                deleteData={deleteData}
                setSelectedItem={setSelectedItem}
                setModal={setModal}
                modal={modal}
            />

            <CrudLanguage
                setChanged={setChanged}
                showMenu={modal}
                setShowMenu={setModal}
                setSelectedItem={setSelectedItem}
                selectedItem={selectedItem}
                t={t}
            />
        </CMS>
    )
}

export default LanguagePage
